import { useLocalStorage } from '@fourthwall/utils/dist/LocalStorage';
const LOCAL_STORAGE_KEY = 'fourthwall.dashboard';
export const useDashboardStorage = () => {
    const { localStorage } = useLocalStorage(LOCAL_STORAGE_KEY);
    return { dashboardStorage: localStorage };
};
